import { createStore as createVuexStore, createLogger } from 'vuex';
import { parseGoal } from '@/goal';
import { migrate } from '@/versioning';
import DeviceThemeWatcher from './plugins/DeviceThemeWatcher';
import TimeTicker from './plugins/TimeTicker';
import optionsMigrations from './migrations/optionsMigrations';
import modules from './modules';
import { parseHistory } from '@/goal/history';
import { DEBUG } from '@/constants';
import logger from '@/logger';
import dl from '@/dataLayer';

export default async function createStore() {
    const store = createVuexStore({
        state() {
            return { };
        },
        getters: {
            locale({ locales, options }) {
                return locales[options.localeKey]
                    ?? locales[window.navigator.userLanguage]
                    ?? locales[window.navigator.language]
                    ?? locales['en-US'];
            },

            activeGoalKeys({ goals }) {
                return goals.keys.filter(x => !goals.archiveKeys.includes(x));
            },
			
            archivedGoalKeys({ goals }) {
                return goals.archiveKeys;
            },
        },
        actions: {
            async boot({dispatch}) {
                await measure('meta/boot', () => dispatch('meta/boot'));
                await measure('options/boot', () => dispatch('options/boot'));
                await measure('goals/boot', () => dispatch('goals/boot'));

                async function measure(name, handler) {
                    const start = performance.now();
                    const result = await handler();
                    logger.log(`PERF: ${name} took ${performance.now() - start}ms`);
                    return result;
                }
            },

            async importStorage({dispatch}, {goals, history, options }) {
                for (const g of goals) {
                    const goal = parseGoal(g);
                    const historyCollection = parseHistory(history[goal.key]);
                    await dispatch('goals/add', { goal, historyCollection });
                }

                migrate('options', options, optionsMigrations);
                await dispatch('options/update', options);
            },

            async clearStorage({commit, dispatch}) {
                await dl.clear();
                commit('goals/clear');
                commit('options/clear');

                dispatch('boot');
            },
        },
        plugins: [...generatePlugins()],
        modules,
    });
    
    await store.dispatch('boot');
    return store;
}

function* generatePlugins() {
    yield TimeTicker;
    yield DeviceThemeWatcher;
    if (DEBUG)
        yield createLogger();
}